import React, { useEffect, useState, Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// Eagerly load layout and utility components
import Nav from "./components/Nav";
import NavSide from "./components/NavSide";
import Footer from "./components/Footer";
import WApp from "./utils/WApp";
import Loader from './utils/Loader';
import CookieConsent, { Cookies } from "react-cookie-consent";

// Eagerly load components for instant navigation as requested
import Home from "./components/Home";
import About from "./components/About";
import Tasar from "./components/Tasar";
import Servicios from "./components/Servicios";
import Finan from "./components/Financiación";
import FAQ from "./components/FAQ";
import CalculadoraFinanciacion from "./components/CalculadoraFinanciacion";

// Lazy load other page components for code splitting
const Coches = lazy(() => import("./components/Coches"));
const FichaCoche = lazy(() => import("./components/FichaCoche"));
const Legal = lazy(() => import("./components/Legal"));
const Login = lazy(() => import("./components/Login"));
const CocheForm = lazy(() => import("./components/CocheForm"));
const OrdenarCoches = lazy(() => import("./components/OrdenarCoches"));
const ProtectedRoute = lazy(() => import("./components/ProtectedRoute"));
const Page404 = lazy(() => import("./utils/Page404"));
const Dashboard = lazy(() => import("./components/Dashboard"));

function App() {
  const [loading, setLoading] = useState(() => {
    // Only show loader on the very first visit per session
    return !sessionStorage.getItem('firstLoadDone');
  });
  const [hasConsented, setHasConsented] = useState(Cookies.get("myAwesomeCookieName2") === "true");

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem('firstLoadDone', 'true');
      }, 1000);
      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [loading]);

  useEffect(() => {
    if (hasConsented) {
      // Place your analytics or other cookie-based scripts here
      // For example, if you were using Google Analytics:
      // const script = document.createElement('script');
      // script.src = "https://www.googletagmanager.com/gtag/js?id=YOUR_GA_ID";
      // script.async = true;
      // document.head.appendChild(script);
      // window.dataLayer = window.dataLayer || [];
      // function gtag(){dataLayer.push(arguments);}
      // gtag('js', new Date());
      // gtag('config', 'YOUR_GA_ID');
      console.log("Cookie consent is given. Loading analytics...");
    }
  }, [hasConsented]);

  return (
    <HelmetProvider>
      <Router> {/* Router now wraps the entire application */}
        <div>
          {loading ? (
            <Loader />
          ) : (
            <>
              <Nav />
              <NavSide />
              <CookieConsent
                location="bottom"
                buttonText="Acepto"
                cookieName="myAwesomeCookieName2"
                style={{ background: "#374a6d80", color: "white" }}
                buttonStyle={{ fontSize: "15px", borderRadius: "21px", background: "#ff8000", color: "white" }}
                expires={150}
                enableDeclineButton
                declineButtonText="Rechazo"
                declineButtonStyle={{ fontSize: "15px", borderRadius: "21px", background: "#6c757d", color: "white" }}
                onAccept={() => {
                  setHasConsented(true);
                }}
                onDecline={() => {
                  setHasConsented(false);
                }}
              >
                Este sitio web utiliza cookies para mejorar la experiencia del usuario. Al hacer clic en Acepto, das tu consentimiento para que se utilicen cookies.
              </CookieConsent>
              
              <Suspense fallback={null}>
                <Routes>
                  {/* Public Routes */}
                  <Route exact path="/" element={<Home />} />
                  <Route exact path="/garaje" element={<Coches />} />
                  <Route exact path="/contacto" element={<About />} />
                  <Route exact path="/tasación" element={<Tasar />} />
                  <Route exact path="/servicios" element={<Servicios />} />
                  <Route path="/coche/:slug/:id" element={<FichaCoche />} />
                  <Route path="/legal" element={<Legal />} />
                  <Route path="/financiación" element={<Finan />} />
                  <Route path="/calculadora-financiacion" element={<CalculadoraFinanciacion />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/faq" element={<FAQ />} />
                  
                  {/* Protected Admin Routes */}
                  <Route element={<ProtectedRoute />}>
                    <Route path="/admin/dashboard" element={<Dashboard />} />
                    <Route path="/crear-coche" element={<CocheForm />} />
                    <Route path="/editar-coche/:id" element={<CocheForm />} />
                    <Route path="/admin/ordenar" element={<OrdenarCoches />} />
                  </Route>

                  <Route path="*" element={<Page404 />} />
                </Routes>
              </Suspense>
              
              <WApp />
              <Footer />
            </>
          )}
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;

